import { useEffect, useRef, useState } from 'react'
import { focusManager, useMutation } from '@tanstack/react-query'
import { markRoomRead } from '../../../api/chat'

const useWindowFocused = (): boolean => {
  const [focused, setFocused] = useState(focusManager.isFocused())
  useEffect(() => focusManager.subscribe(setFocused), [])
  return focused
}

export const useMarkRoomRead = (
  roomId: string,
  latestMessageId: string | undefined
): void => {
  const focused = useWindowFocused()
  const lastSent = useRef<string | null>(null)
  const { mutate } = useMutation({
    mutationFn: markRoomRead,
    meta: { skipGlobalInvalidate: true },
  })

  useEffect(() => {
    if (!focused || !latestMessageId) return
    const key = `${roomId}/${latestMessageId}`
    if (lastSent.current === key) return
    lastSent.current = key
    mutate(roomId)
  }, [focused, latestMessageId, mutate, roomId])
}
